'use strict';

import codepoints from '@dwp/mx-icons-font/dist/codepoints';

window.mx = window.mx || {};
window.mx.components = window.mx.components || {};
mx.components.Icons = codepoints;

export default angular.module('mx.components', []).name;
